module.exports = __webpack_public_path__ + "static/media/jason-frog.99121786.png";